export const RadioItemDefaultKey: string = '#>>';
